import { Component } from '@angular/core';

import { SkeletonModule } from 'primeng/skeleton';
import { ButtonDirective } from 'primeng/button';

@Component({
  selector: 'bn-client-info-skeleton',
  standalone: true,
  imports: [SkeletonModule, ButtonDirective],
  template: `
    <button
      pButton
      type="button"
      [outlined]="true"
      disabled
      class="w-full text-left flex items-stretch justify-between p-0 rounded-lg overflow-hidden focus-visible:ring-2 focus-visible:ring-[var(--p-primary-color)] mb-2"
    >
      <div class="text-left font-normal text-[inherit] text-base leading-normal w-full">
        <div class="w-full flex justify-between">
          <div class="flex items-center gap-3 overflow-hidden">
            <p-skeleton shape="circle" size="2.5rem" styleClass="flex-shrink-0" />

            <div class="flex flex-col min-w-0 overflow-hidden gap-1">
              <p-skeleton width="8rem" height="0.875rem" />
              <p-skeleton width="10rem" height="0.75rem" />
              <p-skeleton width="10rem" height="0.75rem" />
            </div>
          </div>
        </div>
      </div>
    </button>
  `,
})
export class ClientInfoSkeletonComponent {}
